import { motion } from "framer-motion";
import { Phone, Mail, Globe, Instagram, Facebook, MapPin } from "lucide-react";

const contacts = [
  { icon: Phone, label: "Call us", value: "07881 746 762", href: "tel:07881746762", testId: "contact-phone" },
  { icon: Mail, label: "Email", value: "info@JDElectrical.co.uk", href: "mailto:info@JDElectrical.co.uk", testId: "contact-email" },
  { icon: Globe, label: "Website", value: "JDElectrical.co.uk", href: "#top", testId: "contact-web" },
];

export const Contact = () => {
  return (
    <section id="contact" className="py-24 lg:py-32 bg-ink text-white relative overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <p className="font-display text-xs uppercase tracking-[0.25em] text-brand-yellow mb-4">04 — Get in touch</p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-display font-extrabold tracking-tighter text-6xl lg:text-8xl leading-[0.9]"
            >
              Let's get<br />it <span className="text-brand-yellow">sorted.</span>
            </motion.h2>
            <p className="font-body text-white/60 mt-8 text-lg max-w-md leading-relaxed">
              Electrical or air con, big job or small — give us a call or drop a message and we'll take it from there.
            </p>
            <div className="flex items-center gap-3 mt-8">
              <a href="https://instagram.com/JDElectricalLtd" target="_blank" rel="noopener noreferrer" data-testid="social-instagram"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 hover:bg-brand-yellow hover:text-ink transition-colors duration-200">
                <Instagram size={18} />
              </a>
              <a href="https://facebook.com/JDElectricalLtd" target="_blank" rel="noopener noreferrer" data-testid="social-facebook"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 hover:bg-brand-yellow hover:text-ink transition-colors duration-200">
                <Facebook size={18} />
              </a>
              <span className="font-body text-sm text-white/50 ml-2">@JDElectricalLtd</span>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-3">
            {contacts.map((c) => {
              const Icon = c.icon;
              return (
                <a key={c.testId} href={c.href} data-testid={c.testId}
                  className="group flex items-center gap-5 rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:bg-white/[0.07] hover:border-brand-yellow/50 transition-colors duration-300">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/5 group-hover:bg-brand-yellow transition-colors duration-300">
                    <Icon size={20} className="text-white group-hover:text-ink transition-colors duration-300" />
                  </div>
                  <div>
                    <p className="font-body text-xs uppercase tracking-wide text-white/40">{c.label}</p>
                    <p className="font-display text-xl font-bold tracking-tight">{c.value}</p>
                  </div>
                </a>
              );
            })}
            <div className="flex items-center gap-3 rounded-2xl border border-white/10 p-6">
              <MapPin size={18} className="text-brand-yellow" />
              <p className="font-body text-sm text-white/60">Covering the local area & surrounding counties</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
